import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LoadingIndicator, StatusSection } from '../../../../components'
import Button from '../../../../components/Button'
import { useTextButton } from '../../../../utils/useForm'
import { getCIDefaultState, getDowelingDefaultState } from '../../common/fns'
import { crackInjectionCalculation, dowelingCalculation } from '../../store/calculationAction'
import { CrackInjection, Doweling } from './components'

const Input = (props) => {
  const dispatch = useDispatch()

  const calculationDoweling = useSelector((state) => state.calculationDoweling)
  const calculationCI = useSelector((state) => state.calculationCI)
  const calculation = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)

  const { subApp, source, sourceDomain } = calculation.input
  const { dowelingInitialState, crackInjectionInitialState, status } = staticData
  const { isLoading, isError, errorMessage, msgLevel, msgHeader, msgBody } = status
  // const { getCrackInjectionModels } = useStaticData(staticData)
  //
  const onChangeCB = (name, value) => {
    if (subApp === value) {
      return
    }
    // const initialState = (value === '1') ? crackInjectionInitialState : {}
    let initialState = {}
    if (value === '1') {
      if (source === 'EC') {
        if (calculationCI && calculationCI.input === undefined) {
          initialState = Object.assign(
            {},
            getCIDefaultState(crackInjectionInitialState, staticData),
            { source: source, sourceDomain: sourceDomain },
          )
        }
      } else {
        initialState = Object.assign({}, crackInjectionInitialState)
      }
    } else {
      if (source === 'EC') {
        if (calculationDoweling && calculationDoweling.input === undefined) {
          initialState = Object.assign(
            {},
            getDowelingDefaultState(dowelingInitialState, staticData),
            { source: source, sourceDomain: sourceDomain },
          )
        }
      }
    }

    dispatch({ type: 'SWITCH_SUBAPP', payload: { subApp: value, initialState: initialState } })

    if (value === '1') {
      if (calculationCI && calculationCI.input === undefined) {
        dispatch(crackInjectionCalculation(initialState, staticData))
      }
    } else {
      if (source === 'EC' && calculationDoweling && calculationDoweling.input === undefined) {
        dispatch(dowelingCalculation(initialState, staticData))
      }
    }
  }

  const dowelingSubAppButton = useTextButton('subApp', subApp, '0', onChangeCB, false)
  const ciSubAppButton = useTextButton('subApp', subApp, '1', onChangeCB, false)
  //
  // const ErrorMessageSection = () => {
  //   return (
  //     <StatusSection
  //       statusLevel={'error'}
  //       statusIcon={'assets/images/icons/sst-icon-info.svg'}
  //       statusHeader={'Network Error'}
  //       statusBody={'The network connection is currently unavailable to generate results. Please try your calculations again at a later time.'}>
  //     </StatusSection>
  //   )
  // }
  const ErrorMessageSection = () => {
    return (
      <StatusSection
        statusLevel={staticData.status.msgLevel}
        statusIcon={'assets/images/icons/sst-icon-info.svg'}
        statusHeader={staticData.status.msgHeader}
        statusBody={staticData.status.msgBody}
      />
    )
  }

  return (
    <div className="inputSectionWrapper">
      <h2 className="sectionFlag -input">Input</h2>
      <div className="inputSection">
        <div className="container-fluid">
          {isLoading ? (
            <LoadingIndicator />
          ) : (
            <>
              {isError ? (
                <ErrorMessageSection />
              ) : (
                <>
                  <section id="aceInputCondition">
                    <h3>Condition</h3>

                    <div className="buttonGroup row -skinny" label="">
                      <div className="col -skinny">
                        <Button
                          variant="subAppSelector"
                          className={'button ' + (subApp === '0' ? ' -checked' : '')}
                          {...dowelingSubAppButton}
                          data-testid="subApp.doweling"
                        >
                          <img
                            className="illustration"
                            src="https://embed.widencdn.net/svg/ssttoolbox/6p3ia2jexd/A_ThreadedRodAndRebar_InstIll_Ill_Instld_Doweling_C0.svg"
                            alt="Threaded Rod and Rebar Doweling"
                          />
                          <span className="button__text">Threaded Rod and Rebar Doweling</span>
                        </Button>
                      </div>

                      <div className="col -skinny">
                        <Button
                          variant="subAppSelector"
                          className={'button ' + (subApp === '1' ? ' -checked' : '')}
                          {...ciSubAppButton}
                          data-testid="subApp.crackInjection"
                        >
                          <img
                            className="illustration"
                            src="https://embed.widencdn.net/svg/ssttoolbox/2n4lqejjac/A_EIP-EZA_InstIll_Ill_Instld_CrackInjection_C0.svg"
                            alt="Crack Injection"
                          />
                          <span className="button__text">Crack Injection</span>
                        </Button>
                      </div>
                    </div>
                  </section>

                  {subApp === '0' ? <Doweling /> : <CrackInjection />}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default Input
